export default __webpack_public_path__ + "static/media/careteam_my_tickets_prescription_generated.85854248.svg";